export const reservationListFilterState = (venue) => ({
  venueId: venue.venueId,
  page: 1,
  pageSize: 20,
  searchKey: "",
  dateRange: [null, null],
});
